import React from 'react';
import { UserGroupIcon, LightBulbIcon, CalendarIcon, ChartBarIcon, TrendingUpIcon, SupportIcon } from '@heroicons/react/outline';
import withAnimation from '../../../hooks/withAnimation';

const features = [
  {
    icon: <LightBulbIcon className="h-8 w-8 text-primary" />,
    title: "Alleviate Your Pain",
    description: "Our dedicated team will collaborate with you to develop a personalized care plan tailored to manage your pain and help you reach your objectives."
  },
  {
    icon: <ChartBarIcon className="h-8 w-8 text-primary" />,
    title: "Gain Empowerment",
    description: "With a bespoke plan and expert support, you’ll gain confidence in managing your health and well-being effectively."
  },
  {
    icon: <UserGroupIcon className="h-8 w-8 text-primary" />,
    title: "Trusted Support",
    description: "Our approachable and skilled clinicians are here to address your questions and support you in achieving your goals."
  },
  {
    icon: <CalendarIcon className="h-8 w-8 text-primary" />,
    title: "Enhanced Recreational and Sports Performance",
    description: "Whether you’re a casual athlete or just passionate about staying active, we can help you enhance your performance and reduce the risk of injury."
  },
  {
    icon: <TrendingUpIcon className="h-8 w-8 text-primary" />,
    title: "Greater Mobility and Function",
    description: "By concentrating on movement and activity, we’ll assist you in restoring your mobility and boosting your overall functionality."
  },
  {
    icon: <SupportIcon className="h-8 w-8 text-primary" />,
    title: "A Forward-Looking Plan",
    description: "Our aftercare program is designed to sustain your progress and keep you on the path to a brighter, healthier future."
  }
];

const FeatureSection = () => {
  return (
    <section className="py-14 bg-lightBackground px-6 lg:px-12">
      <div className="container mx-auto text-center">
        <h2 className="text-3xl font-bold text-black lg:text-4xl">
          Transform Your Life with Conklin
        </h2>
        <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto">
          Discover the benefits of physiotherapy, personalized care, and
          expert guidance to help you live a healthier and more active life.
        </p>
        <div className="flex flex-wrap justify-center gap-8 mt-12">
          {features.map((feature, index) => (
            <div key={index} className="w-full sm:w-1/2 lg:w-1/4 p-4">
              <div className="flex h-full flex-col items-center space-y-4 bg-white shadow-lg p-6 rounded-lg">
                <div className="bg-[#FDF5EF] p-5 rounded-full">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-semibold text-gray-900">
                  {feature.title}
                </h3>
                <p className="text-gray-700 text-pretty">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default withAnimation(FeatureSection);
